import { call, put, takeLatest } from 'redux-saga/effects';

import { getServices } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const response = yield call(getServices, { id: action.payload });
  yield put(
    response.isOk ? requestSuccess(response.data, action.payload) : requestFailure(response.error),
  );
}

export default function* servicesSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
